import type { ReactNode } from 'react';

export const symbol_sync_problem: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M459-291q-9-9-9-21t9-21q9-9 21-9t21 9q9 9 9 21t-9 21q-9 9-21 9t-21-9Zm1.5-147.5Q452-447 452-460v-189q0-13 8.5-21.5T482-679q13 0 21.5 8.5T512-649v189q0 13-8.5 21.5T482-430q-13 0-21.5-8.5ZM188-477q0 64 27.5 117.5T305-266v-94q0-13 8.5-21.5T335-390q13 0 21.5 8.5T365-360v170q0 13-8.5 21.5T335-160H165q-13 0-21.5-8.5T135-190q0-13 8.5-21.5T165-220h100q-64-48-100.5-108.5T128-477q0-89 46.5-167.5T308-765q11-5 21.5-.5T345-750q4 11 0 22.5T330-711q-62 32-102 94.5T188-477Zm594-6q0-64-27.5-117.5T665-694v94q0 13-8.5 21.5T635-570q-13 0-21.5-8.5T605-600v-170q0-13 8.5-21.5T635-800h170q13 0 21.5 8.5T835-770q0 13-8.5 21.5T805-740H705q64 48 100.5 108.5T842-483q0 89-46.5 168T662-194q-11 5-21.5 0T625-210q-4-11 0-22.5t15-16.5q62-32 102-94.5T782-483Z"
		/>
	</svg>
);
